import React, { Component } from 'react';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Check from '@material-ui/icons/Check';

export class ManageUserListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
      selectedUser: {},
    };
  }

  onMouseEnter = () => {
    this.setState({ hovered: true });
  };

  onMouseLeave = () => {
    this.setState({ hovered: false });
  };

  handleSelectUser = () => {
    this.setState({ selectedUser: {} }, () => {
      this.setState({ selectedUser: { ...this.props.member, password: "" } }, () => {
        this.props.callbackFromParent(this.state.selectedUser);
      });
    });
  };

  render() {
    const style = this.state.hovered ? { backgroundColor: "#ebebeb" } : {};
    const userName = <Typography style={{ fontSize: '14px', paddingBottom: '3px', paddingLeft: '3px' }}>{this.props.member.firstName} {this.props.member.lastName}</Typography>;
    
    let canManage;
    let canViewLog;
    let userRoles = this.props.member.roles || "";

    // if (userRoles.includes("A")) {
    if (userRoles.includes("A") || userRoles.includes("D")) {
    // if (this.props.canManageChecked) {
      canManage = <Typography align="center"><Check style={{ color: 'green' }} /></Typography>;
    } else {
      canManage = <div></div>;
    }

    if (userRoles.includes("A")) {
    // if (this.props.canViewLogsChecked) {
      canViewLog = <Typography align="center"><Check style={{ color: 'green' }} /></Typography>;
    } else {
      canViewLog = <div></div>;
    }

    return (
      <div style={{ flexgrow: '1', margin: '0px' }} onClick={this.handleSelectUser}>
        <Grid container spacing={0} style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
          <Grid item xs={6}>{userName}</Grid>
          <Grid item xs={6}>{canManage}</Grid>
          {/*<Grid item xs={3}>{canViewLog}</Grid>*/}
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

export default connect(mapStateToProps, null)(ManageUserListItem);


// WEBPACK FOOTER //
// ./src/components/ManageUserListItem.js